__webpack_require__.p = "/admin/_next/";